// root
const root = `https://europe-west3-prod-eu-wav.cloudfunctions.net` //production
// const root ='http://localhost:5001/dev-wav/europe-west3'  //local db link
// const root ='https://europe-west3-dev-wav.cloudfunctions.net/' //development link
// 
// console.log('root', root)
export const immagaSuggestions = `${root}/imaggaSuggestions`
// test function
export const testFunction = `${root}/testFunction`
// custom list
export const getCustomList = `${root}/getPhotosInCustomList`

export const getFilteredPhotos = `${root}/getFilteredPhotos_3`

export const operationOnPhoto = `${root}/operationOnPhoto`

export const getParticularPhotoDetails = `${root}/getParticularPhotoDetails_2`

/*
  this api check if user is registering on the website for the first time,
  or user is already registered on the site, technically on first time register,
  it created some field in database against user's id.
*/
export const newUserAccountSetup = `${root}/newUserAccountSetup`
// user profile details
export const userProfileDetails = (payload) => `${root}/getBasicProfileDetails_3?profileUid=${payload.uid}`
// wishlist/shared/checkins profile images
export const profileImages = `${root}/getOtherProfileDetails_3?isCron=${false}`

export const uploadImage = `${root}/uploadImage`

//export const editBasicProfileDetails = `${root}/editBasicProfileDetails?isCron=${false}`
export const editBasicProfileDetails = `${root}/updateProfileBasicDetails`

// mark exposure
export const markExposure = `${root}/markExposure?isCron=${false}`

// get elsewhere pics
export const getElsewherePics = `${root}/getFilteredPhotos_2`

// get nearby photos
export const getNearbyPhotos = (payload) => `${root}/nearby_photos_2?geohash=${payload.geohash}&startAt=${payload.startAt}&limit=${payload.limit}&photoId=${payload.photoId}&isProperty=${payload.isProperty}&masterPropertyId=${payload.masterPropertyId}`
// get user filters
export const getUserAllFilters = (tag) => `${root}/user_get_all_filters?tagCat=${tag}`
// image det - Top section
export const _top_image_section = (payload)=> `${root}/imgDet_top?photoId=${payload.photoId}&isLoggedIn=${payload.isLoggedIn}&uid=${payload.uid}`
// get suggestions
export const getSuggestions = payload => `${root}/getTagSuggestions?limit=15&tagCat=${payload.tagCat}`
// upload new api
export const upload_2 = `${root}/upload_2`

export const createCustomToken = `${root}/create_custom_token`



// WEBPACK FOOTER //
// ./src/api.js